

export interface ISequenceDefinition {
    id: number,
    entityName: string,
    code: string,
    isActive: boolean,
    name: string,
    numberExpression: string,
    resetType: 'n' | 'y' | 'm' | 'd',
    incrementBy: number,
    startValue: number,

    entityDescription: string
  }


   export const defaultSequenceDefinition : ISequenceDefinition = {
      id: 0,
      entityName: '',
    code: '',
    isActive: true,
    name: '',
    numberExpression: '',
    resetType: 'n',
    incrementBy: 1,
    startValue: 1,

    entityDescription: ''
   }

  export interface ISequenceCounter {
    id: number,
    
    sequenceDefinitionId: number,
    year: number,
    month: number,
    day: number,
    currentValue: number,    
  }


  export interface ISequenceDefinitionSearch {
    code: string,
    name: string,

    entityName: string,
  }